
import storage from '../../utils/storage';
import Types from '../types';

export const toggleTheme = (payload) => {
    return async function (dispatch) {
        storage.setItem('themeType', payload)
        dispatch({
            type: Types.TOGGLE_THEME,
            payload: payload
        });
    }
}

export const setGlobalLoader = (payload) => {
    return async function (dispatch) {
        dispatch({
            type: Types.GLOBAL_LOADER,
            payload: payload
        });
    }
}

export const showSnackbar = (payload) => {
    return async function (dispatch) {
        dispatch({
            type: Types.SNACKBAR,
            payload: payload
        });
    }
}

export const showProgressLoader = (show) => {
    return async function (dispatch) {
        if (show) {
            dispatch({
                type: Types.SHOW_PROGRESS_BAR,
                payload: show
            });
            dispatch(setProgressBarValue(0))
        }
        else {
            setTimeout(() => {
                dispatch({
                    type: Types.SHOW_PROGRESS_BAR,
                    payload: show
                });
            }, 300);
            dispatch(setProgressBarValue(90))
            dispatch(setProgressBarValue(100))
        }
    }
}

export const setProgressBarValue = (payload) => {
    return async function (dispatch) {
        dispatch({
            type: Types.PROGRESS_BAR_VALUE,
            payload: payload
        });
    }
} 